import { useCallback, useEffect, useState } from "react";
import { BaseControlledModal } from "../../../../../../common/components/base_controlled_modal";
import { MaskedInput } from "../../../../../../common/components/masked_inputs/masked_input";

import FormContainer from "../../../../../../common/components/form_container";

/**
 * InspecaoObraCopyModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  onClose: (idMapaConcretagem: number | null, openState: boolean) => void;
  onSubmit: (copyNumber: number) => void;
};

export const InspecaoObraCopyModal = ({
  open,
  saving,
  loading,
  onClose,
  onSubmit,
}: Props) => {
  const [copyNumber, setCopyNumber] = useState<number>();
  const [helperText, setHelperText] = useState<string>();

  useEffect(() => {
    if (open) {
      setCopyNumber(undefined);
      setHelperText(undefined);
    }
  }, [
    open,
  ]);

  const handleSubmit = useCallback(() => {
    if (copyNumber) {
      if (!saving && !loading) {
        onSubmit(copyNumber);
        setCopyNumber(undefined);
      }
    } else {
      setHelperText("Este campo deve ser preenchido!");
    }
  }, [
    copyNumber,
    saving,
    loading,
    onSubmit,
  ]);

  return (
    <BaseControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Copiar Verificação de Inspeção'
      onClose={() => onClose(null, false)}
      onSubmit={() => handleSubmit()}>
      <FormContainer title="Gerar Quantas Cópias?" arrangement="fullRow">
        <MaskedInput
          name='copyNumber'
          label='Número de copias'
          mask='000'
          maskPlaceholder='___'
          value={copyNumber ? copyNumber.toString() : ""}
          helperText={helperText}
          onChange={e => {
            setHelperText(undefined);
            setCopyNumber(Number(e));
          }}
        />
      </FormContainer>
    </BaseControlledModal>
  );
}